import { inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';
import { GLOBAL_LOADER_NAME } from '../constants/loader.constants';

@Injectable({ providedIn: 'root' })
export class GlobalLoaderService {
  private readonly ngxSpinnerService = inject(NgxSpinnerService);

  private readonly loadingBehaviourSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  private readonly textBehaviourSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  public readonly loading$ = this.loadingBehaviourSubject.asObservable();
  public readonly text$ = this.textBehaviourSubject.asObservable();

  private timeoutId?: number;

  public show(text?: string | null, timeout = 30000): void {
    window.clearTimeout(this.timeoutId);

    this.loadingBehaviourSubject.next(true);
    this.textBehaviourSubject.next(text ?? null);

    this.ngxSpinnerService.show(GLOBAL_LOADER_NAME);

    this.timeoutId = window.setTimeout(() => {
      this.hide();
    }, timeout);
  }

  public hide(): void {
    window.clearTimeout(this.timeoutId);

    this.loadingBehaviourSubject.next(false);
    this.textBehaviourSubject.next(null);

    this.ngxSpinnerService.hide(GLOBAL_LOADER_NAME);
  }
}
